import { useMemo, useRef } from 'react';
export function useCloseRef() {
    return useRef(function () { return undefined; });
}
export function useOptionalCloseRef(closeRef) {
    var fallbackCloseRef = useCloseRef();
    return useMemo(function () { return closeRef !== null && closeRef !== void 0 ? closeRef : fallbackCloseRef; }, [fallbackCloseRef, closeRef]);
}
